// Centralized room data — 5 types with full bilingual descriptions, facilities, and seasonal pricing.
// Seasonal pricing: Low Season (Jan–Jun, Sep–Nov) · High Season (Jul–Aug) · Peak (20 Dec – 5 Jan, uses High rates)
// BF = Breakfast (optional add-on, pre-included in some rate tiers)

export function getCurrentSeason() {
  const d = new Date();
  const m = d.getMonth() + 1;
  const day = d.getDate();
  if ((m === 12 && day >= 20) || (m === 1 && day <= 5)) return "peak";
  if (m === 7 || m === 8) return "high";
  return "low";
}

// For UI, we fold "peak" into "high" pricing but label it separately
export function pricingTierOf(season) {
  return season === "peak" ? "high" : season;
}

export const ROOMS = [
  {
    id: "standard-garden",
    slug: "standard-garden-view",
    name: { en: "Standard Garden View", id: "Standard Garden View" },
    tagline: {
      en: "Comfortable room with a tropical Balinese garden atmosphere",
      id: "Kamar nyaman dengan suasana taman tropis Bali",
    },
    description: {
      en: "Enjoy a comfortable stay in our Standard Garden View room — simple, warm, and surrounded by a lush green garden with authentic Balinese character. Ideal for solo travellers and couples seeking an affordable base in Pererenan, Canggu. This room sits closer to the main road, so you may occasionally hear passing vehicles.",
      id: "Nikmati pengalaman menginap yang nyaman di kamar Standard Garden View Agung Wiwin Homestay. Kamar ini menawarkan suasana sederhana dan hangat dengan pemandangan taman hijau yang memberikan nuansa khas Bali. Cocok untuk wisatawan solo maupun pasangan yang ingin menikmati liburan di kawasan Pererenan, Canggu. Kamar ini terletak di area yang lebih dekat dengan jalan, sehingga sesekali suara kendaraan mungkin terdengar.",
    },
    capacity: { en: "Max 2 adults", id: "Maksimal 2 orang dewasa" },
    bedSize: "Queen 160 × 200 cm",
    facilities: {
      en: ["Queen bed (160 × 200)", "Air conditioning", "Private bathroom", "Wi-Fi", "Private terrace", "Work desk & wardrobe", "Electric kettle", "Minibar", "Garden view", "Shared pool access"],
      id: ["Tempat tidur Queen (160 × 200 cm)", "AC", "Kamar mandi pribadi", "Wi-Fi", "Teras pribadi", "Meja kerja & lemari pakaian", "Ketel listrik", "Minibar", "Pemandangan taman", "Akses kolam renang bersama"],
    },
    pricing: {
      low:  { noBf: 400000, withBf: 450000 },
      high: { noBf: 450000, withBf: 500000 },
      monthly: { low: 9000000, high: 10000000 },
    },
  },
  {
    id: "standard-pool",
    slug: "standard-pool-view",
    name: { en: "Standard Pool View", id: "Standard Pool View" },
    tagline: {
      en: "Comfortable room overlooking the swimming pool",
      id: "Kamar nyaman dengan pemandangan kolam renang",
    },
    description: {
      en: "Enjoy a delightful stay in our Standard Pool View room — a tropical Balinese setting with direct views of the swimming pool, perfect for unwinding during your holiday. Ideal for solo travellers and couples seeking a quiet, comfortable base in Pererenan, Canggu. This room sits reasonably close to the main road, so you may occasionally hear passing vehicles.",
      id: "Nikmati pengalaman menginap yang menyenangkan di kamar Standard Pool View Agung Wiwin Homestay. Kamar ini menawarkan suasana tropis khas Bali dengan pemandangan langsung ke area kolam renang, cocok untuk bersantai dan menikmati waktu liburan Anda. Pilihan ideal bagi wisatawan solo maupun pasangan yang ingin menikmati suasana tenang dan nyaman di kawasan Pererenan, Canggu. Kamar ini terletak di area yang cukup dekat dengan jalan, sehingga sesekali suara kendaraan mungkin terdengar.",
    },
    capacity: { en: "Max 2 adults", id: "Maksimal 2 orang dewasa" },
    bedSize: "Queen 160 × 200 cm",
    facilities: {
      en: ["Queen bed (160 × 200)", "Air conditioning", "Private bathroom", "Wi-Fi", "Private terrace", "Work desk & wardrobe", "Electric kettle", "Minibar", "Pool view", "Direct access to shared pool"],
      id: ["Tempat tidur Queen (160 × 200 cm)", "AC", "Kamar mandi pribadi", "Wi-Fi", "Teras pribadi", "Meja kerja & lemari pakaian", "Ketel listrik", "Minibar", "Pemandangan kolam renang", "Akses langsung ke area kolam renang bersama"],
    },
    pricing: {
      low:  { noBf: 450000, withBf: 500000 },
      high: { noBf: 500000, withBf: 550000 },
      monthly: { low: 11000000, high: 12000000 },
    },
  },
  {
    id: "deluxe-garden",
    slug: "deluxe-garden-view",
    name: { en: "Deluxe Garden View", id: "Deluxe Garden View" },
    tagline: {
      en: "A quieter stay surrounded by tropical gardens",
      id: "Kamar nyaman dengan suasana taman tropis yang lebih tenang",
    },
    description: {
      en: "A peaceful stay enveloped by lush tropical gardens. The Deluxe Garden View sits further from the main road than the Standard rooms, offering a quieter atmosphere with less traffic noise — ideal for solo travellers, couples, or guests planning a longer stay in Pererenan, Canggu.",
      id: "Nikmati pengalaman menginap yang nyaman dan menenangkan di kamar Deluxe Garden View Agung Wiwin Homestay. Dikelilingi suasana taman tropis yang asri, kamar ini menawarkan lingkungan yang lebih tenang dan cocok bagi Anda yang ingin bersantai serta menikmati keindahan suasana khas Bali. Kamar Deluxe Garden View terletak lebih jauh dari jalan utama dibandingkan tipe kamar Standard, sehingga memberikan suasana yang lebih nyaman dengan lebih sedikit gangguan suara kendaraan.",
    },
    capacity: { en: "Max 2 adults", id: "Maksimal 2 orang dewasa" },
    bedSize: "Queen 160 × 200 cm",
    facilities: {
      en: ["Queen bed (160 × 200)", "Air conditioning", "Private bathroom", "Wi-Fi", "Private terrace", "Work desk & wardrobe", "Electric kettle", "Minibar", "Tropical garden view", "Shared pool access"],
      id: ["Tempat tidur Queen (160 × 200 cm)", "AC", "Kamar mandi pribadi", "Wi-Fi", "Teras pribadi", "Meja kerja & lemari pakaian", "Ketel listrik", "Minibar", "Pemandangan taman tropis", "Akses kolam renang bersama"],
    },
    pricing: {
      low:  { noBf: 450000, withBf: 500000 },
      high: { noBf: 525000, withBf: 575000 },
      monthly: { low: 11000000, high: 12000000 },
    },
  },
  {
    id: "deluxe-pool",
    slug: "deluxe-pool-view",
    name: { en: "Deluxe Pool View", id: "Deluxe Pool View" },
    tagline: {
      en: "Direct pool views with a tropical Bali atmosphere",
      id: "Pemandangan kolam renang & suasana tropis Bali",
    },
    description: {
      en: "Our Deluxe Pool View blends comfort, scenic views, and the tropical Balinese atmosphere. Located around the pool area, guests can enjoy easy access to swim, relax, or simply soak in the setting. Ideal for solo travellers, couples, and longer-stay guests in Pererenan, Canggu.",
      id: "Nikmati pengalaman menginap yang nyaman dan menyenangkan di kamar Deluxe Pool View Agung Wiwin Homestay. Dengan pemandangan langsung ke area kolam renang yang dikelilingi taman tropis yang asri, kamar ini menawarkan suasana santai dan menyegarkan untuk melengkapi liburan Anda di Bali. Lokasinya berada di sekitar area kolam renang, memberikan kemudahan bagi tamu yang ingin berenang, bersantai, atau sekadar menikmati suasana penginapan.",
    },
    capacity: { en: "Max 2 adults", id: "Maksimal 2 orang dewasa" },
    bedSize: "Queen 160 × 200 cm",
    facilities: {
      en: ["Queen bed (160 × 200)", "Air conditioning", "Private bathroom", "Wi-Fi", "Private terrace", "Work desk & wardrobe", "Electric kettle", "Minibar", "Pool view", "Shared pool access"],
      id: ["Tempat tidur Queen (160 × 200 cm)", "AC", "Kamar mandi pribadi", "Wi-Fi", "Teras pribadi", "Meja kerja & lemari pakaian", "Ketel listrik", "Minibar", "Pemandangan kolam renang", "Akses kolam renang bersama"],
    },
    pricing: {
      low:  { noBf: 500000, withBf: 550000 },
      high: { noBf: 575000, withBf: 625000 },
      monthly: { low: 13000000, high: 14500000 },
    },
  },
  {
    id: "big-room",
    slug: "big-room-suite",
    name: { en: "Big Room / Suite", id: "Big Room / Suite" },
    tagline: {
      en: "Spacious suite with premium comforts for a memorable Bali stay",
      id: "Kamar luas & eksklusif dengan kenyamanan maksimal",
    },
    description: {
      en: "Our most generous room — the Big Room / Suite — pairs a warm, calming atmosphere with premium amenities. A King-size bed, lounge sofa, and private bathroom with bathtub create the perfect space to unwind after a day exploring Bali. Ideal for couples and longer-stay guests who want extra space and comfort in Pererenan, Canggu.",
      id: "Nikmati pengalaman menginap yang lebih istimewa di kamar Big Room / Suite Agung Wiwin Homestay. Dengan ruangan yang lebih luas, desain yang nyaman, dan fasilitas yang lebih lengkap, kamar ini menjadi pilihan ideal bagi Anda yang menginginkan kenyamanan ekstra selama berada di Bali. Big Room menawarkan suasana yang hangat dan menenangkan, dilengkapi dengan tempat tidur King Size, sofa untuk bersantai, serta kamar mandi pribadi dengan bathtub.",
    },
    capacity: {
      en: "Max 2 adults · extra bed available on request (surcharge)",
      id: "Maksimal 2 orang dewasa · tambahan tempat tidur tersedia sesuai permintaan (biaya tambahan)",
    },
    bedSize: "King 200 × 200 cm",
    facilities: {
      en: ["King bed (200 × 200)", "Air conditioning", "Private bathroom with bathtub", "Hot & cold water", "Wi-Fi", "Television", "Sofa & lounge area", "Refrigerator", "Electric kettle", "Work desk & wardrobe", "Hair dryer", "Private terrace", "Shared pool access"],
      id: ["Tempat tidur King Size (200 × 200 cm)", "AC", "Kamar mandi pribadi dengan bathtub", "Air panas dan dingin", "Wi-Fi", "Televisi", "Sofa dan area duduk", "Kulkas", "Ketel listrik", "Meja kerja dan lemari pakaian", "Pengering rambut (Hair Dryer)", "Teras pribadi", "Akses ke kolam renang bersama"],
    },
    pricing: {
      low:  { noBf: 700000, withBf: 750000 },
      high: { noBf: 800000, withBf: 850000 },
      monthly: { low: 15000000, high: 17000000 },
    },
  },
];

export const SEASON_WINDOWS = [
  { tier: "low",  rangeEn: "Jan – Jun · Sep – Nov", rangeId: "Januari – Juni · September – November" },
  { tier: "high", rangeEn: "Jul – Aug",             rangeId: "Juli – Agustus" },
  { tier: "peak", rangeEn: "20 Dec – 5 Jan",        rangeId: "20 Desember – 5 Januari" },
];
